import { render, staticRenderFns } from "./AttachmentSettings.vue?vue&type=template&id=38ec9e2a&scoped=true"
import script from "./AttachmentSettings.vue?vue&type=script&lang=ts"
export * from "./AttachmentSettings.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentSettings.vue?vue&type=style&index=0&id=38ec9e2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec9e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ec9e2a')) {
      api.createRecord('38ec9e2a', component.options)
    } else {
      api.reload('38ec9e2a', component.options)
    }
    module.hot.accept("./AttachmentSettings.vue?vue&type=template&id=38ec9e2a&scoped=true", function () {
      api.rerender('38ec9e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/AttachmentSettings.vue"
export default component.exports